import { forwardRef } from 'react'

const RingIndicator = forwardRef((props, ref) => {
    const { className, style, ...rest } = props

    return (
        <svg ref={ref} viewBox="0 0 24 24" fill="none" className={className} style={style} {...rest}>
            <circle cx="12" cy="12" r="9.5" stroke="currentColor" strokeWidth="2.5" className="opacity-20" />
            <circle cx="12" cy="12" r="9.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" pathLength="100" className="animate-spinner-dash" />
        </svg>
    )
})

RingIndicator.displayName = 'RingIndicator'

export default RingIndicator
